
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","fill":"#6ECB63"}}),_c('g',{attrs:{"clip-path":"url(#clip0_911_3297)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.82 19.489h2.549c.038 1.508.407 2.665 1.083 3.495L13.894 23c.632-.866.97-2.01.925-3.511z","fill":"#CECECE"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.96 9h12.08c1.078 0 1.96.88 1.96 1.954v7.06a2.499 2.499 0 01-2.495 2.488h-11.01A2.499 2.499 0 018 18.015v-7.061C8 9.879 8.882 9 9.96 9z","fill":"#E6E6E6"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.237 9.524h11.517c.876 0 1.592.715 1.592 1.587v5.665c0 1.15-.943 2.09-2.096 2.09H10.74a2.099 2.099 0 01-2.095-2.09v-5.665c0-.873.716-1.587 1.591-1.587z","fill":"#fff"}}),_c('path',{attrs:{"d":"M16.145 20.025a.326.326 0 10.001-.652.326.326 0 00-.001.652z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.574 10.886h5.897c.16 0 .29.162.29.36v2.044c0 .198-.13.36-.29.36h-5.897c-.16 0-.29-.162-.29-.36v-2.044c0-.198.13-.36.29-.36zM10.631 14.738h10.562c.286 0 .52.162.52.36v2.044c0 .198-.234.36-.52.36H10.631c-.286 0-.52-.162-.52-.36v-2.044c0-.198.234-.36.52-.36z","fill":"#E6E6E6"}}),_c('path',{attrs:{"d":"M17.276 11.225a.053.053 0 110-.106h3.442a.053.053 0 110 .106h-3.442zM17.317 12.44a.053.053 0 110-.106h3.044a.053.053 0 110 .106h-3.044zM17.3 13.592a.053.053 0 110-.106h4.047a.053.053 0 110 .106H17.3z","fill":"#E6E6E6"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_911_3297"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(8 9)","d":"M0 0h16v14H0z"}})])])])
          )
        }
      }
    